import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/file-add.svg'
import _imports_1 from '@/assets/img/icons-img/camera2.svg'
import _imports_2 from '@/assets/img/icons-img/videocam.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c97d734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-group" }
const _hoisted_2 = {
  key: 0,
  class: "row gx-20"
}
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"margin-left":"4px"}
  })
], -1))
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = {
  for: "mediaInput",
  class: "btn-ico"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    style: {"margin-bottom":"4px"}
  })
], -1))
const _hoisted_9 = { class: "text" }
const _hoisted_10 = {
  key: 1,
  class: "row gx-20"
}
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"margin-left":"4px"}
  })
], -1))
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    style: {"margin-bottom":"4px"}
  })
], -1))
const _hoisted_16 = { class: "text" }
const _hoisted_17 = {
  key: 2,
  class: "row gx-20"
}
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"margin-left":"4px"}
  })
], -1))
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    style: {"margin-bottom":"4px"}
  })
], -1))
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "col-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {"margin-left":"4px","height":"30px"}
  })
], -1))
const _hoisted_26 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_skeleton_take_photo = _resolveComponent("app-skeleton-take-photo")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", {
                class: "btn-ico",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createCase && _ctx.createCase(...args)))
              }, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$localize('home.button.new_case')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$localize('home.button.new_picture')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mainStore.isFlutter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", {
                class: "btn-ico",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createCase && _ctx.createCase(...args)))
              }, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$localize('home.button.new_case')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", {
                class: "btn-ico",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.flutterOpenCamera && _ctx.flutterOpenCamera(...args)))
              }, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$localize('home.button.new_picture')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mainStore.isAndroid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", {
                style: {"display":"block"},
                class: "btn-ico",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createCase && _ctx.createCase(...args)))
              }, [
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$localize('home.button.new_case')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", {
                for: "mediaInput",
                class: "btn-ico",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_IMAGE)))
              }, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$localize('home.button.camera.image')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", {
                for: "mediaInput",
                class: "btn-ico",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_VIDEO)))
              }, [
                _hoisted_25,
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$localize('home.button.camera.video')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("input", {
        id: "mediaInput",
        ref: "mediaInputRef",
        key: _ctx.mediaLoadedKey,
        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addMedia($event))),
        accept: "video/*, image/*",
        capture: "environment",
        type: "file"
      }, null, 544)), [
        [_vShow, false]
      ])
    ]),
    (!!_ctx.isSaving)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.loaderText
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaProcessing)
      ? (_openBlock(), _createBlock(_component_app_skeleton_take_photo, { key: 1 }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      _createVNode(_component_app_take_photo, {
        ref: "appTakePhoto",
        image: _ctx.mediaToCrop,
        labels: _ctx.labels,
        onOnCancel: _ctx.handleMediaCancel,
        onOnDone: _ctx.handleMultipleUpload,
        onOnRetake: _ctx.handleRetake,
        "is-case-cropper": ""
      }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
    ]))
  ], 64))
}